import * as api from "../Api";

export const newIndividualInvestments = () => async (dispatch) => {
  try {
    const { data } = await api.newIndividualInvestments();
    dispatch({ type: "NEW_INDIVIDUAL_INVESTMENTS", payload: data });
  } catch (error) {}
};

export const approveNewIndividualInvestment =
  (id, postData) => async (dispatch) => {
    try {
      await api.updateIndividualInvestment(id, postData);
      dispatch({ type: "APPROVE_INDIVIDUAL_NEW_INVESTMENT", payload: id });
    } catch (error) {}
  };

export const deleteIndividualInvestment = (id) => async (dispatch) => {
  try {
    await api.deleteIndividualInvestment(id);
    dispatch({ type: "DELETE_INDIVIDUAL_NEW_INVESTMENT", payload: id });
  } catch (error) {}
};
